import React from 'react';
import { IconBase } from '../Base';
export const IconChevronDownLarge = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M16 7.25L10 12.75L4 7.25", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=DownLarge.js.map